import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import SyntaxHighlighter, {
  SyntaxHighlighterProps,
} from 'react-syntax-highlighter';
import {
  a11yDark,
  a11yLight,
} from 'react-syntax-highlighter/dist/cjs/styles/hljs';

import styles from './CustomCode.module.scss';

export const INLINE_CODE = 'inline';

interface CustomCodeProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  isDark?: boolean;
  language?: string;
  customStyle?: SyntaxHighlighterProps['customStyle'];
  showLineNumbers?: boolean;
}

export const CustomCode = ({
  children,
  language = 'python',
  isDark = true,
  customStyle = {},
  showLineNumbers = true,
}: CustomCodeProps) => {
  if (typeof children === 'string') {
    return language === INLINE_CODE ? (
      <code>{children}</code>
    ) : (
      <SyntaxHighlighter
        className={styles.styledSyntaxHighlighter}
        language={language}
        style={isDark ? a11yDark : a11yLight}
        customStyle={customStyle}
        showLineNumbers={showLineNumbers}
      >
        {children}
      </SyntaxHighlighter>
    );
  }

  return null;
};
